// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════
   DESIGN TOKENS
══════════════════════════════════════ */
:root {
  --bg:            #f0f2f5;
  --surface:       #ffffff;
  --surface-2:     #f7f8fa;
  --border:        #e4e7ed;
  --accent:        #1a73e8;
  --accent-dark:   #1252a3;
  --accent-soft:   #e8f0fe;
  --accent-glow:   rgba(26,115,232,0.22);
  --danger:        #ef4444;
  --danger-soft:   #fef2f2;
  --success:       #22c55e;
  --success-soft:  #f0fdf4;
  --text-primary:  #0f1117;
  --text-secondary:#4b5563;
  --text-muted:    #9ca3af;
  --font:          'Sora', sans-serif;
  --font-mono:     'JetBrains Mono', monospace;
  --ease:          cubic-bezier(0.16, 1, 0.3, 1);
}

* { box-sizing: border-box; margin: 0; padding: 0; }

/* ══════════════════════════════════════
   PAGE BACKGROUND
══════════════════════════════════════ */
.profile-page-bg {
  min-height: 100vh;
  background-color: var(--bg);
  padding: 90px 20px 60px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-family: var(--font);
}

/* ══════════════════════════════════════
   PROFILE CARD
══════════════════════════════════════ */
.user-profile-card {
  width: 100%;
  max-width: 620px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 24px;
  box-shadow:
    0 1px 3px rgba(0,0,0,0.05),
    0 8px 32px rgba(0,0,0,0.09),
    0 40px 80px rgba(0,0,0,0.05);
  overflow: hidden;
  animation: cardIn 0.45s var(--ease) both;
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* ── Hero Banner ── */
.user-profile-card::before {
  content: '';
  display: block;
  height: 110px;
  background: linear-gradient(135deg, #1252a3 0%, #1a73e8 50%, #4a9af5 85%, #74b9ff 100%);
}

/* Subtle diagonal stripe texture on banner */
.user-profile-card::after {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 110px;
  background-image: repeating-linear-gradient(
    -55deg,
    transparent 0px, transparent 18px,
    rgba(255,255,255,0.04) 18px, rgba(255,255,255,0.04) 36px
  );
  pointer-events: none;
  border-radius: 24px 24px 0 0;
}

/* ══════════════════════════════════════
   AVATAR
══════════════════════════════════════ */
.profile-image-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -56px;
  margin-bottom: 10px;
  position: relative;
  z-index: 2;
}

.profile-image-wrapper {
  position: relative;
  width: 112px;
  height: 112px;
  border-radius: 50%;
  overflow: visible;
  border: 4px solid #fff;
  box-shadow:
    0 0 0 3px var(--accent),
    0 12px 40px rgba(26,115,232,0.30);
  cursor: pointer;
  transition: box-shadow 0.3s var(--ease), transform 0.3s var(--ease);
}

.profile-image-wrapper:hover {
  transform: scale(1.05) translateY(-2px);
  box-shadow:
    0 0 0 4px var(--accent),
    0 20px 50px rgba(26,115,232,0.42);
}

.profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.profile-image-overlay {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(18,82,163,0.50);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.25s ease;
}

.profile-image-wrapper:hover .profile-image-overlay { opacity: 1; }
.profile-image-overlay i { color: white; font-size: 20px; }

.camera-icon {
  position: absolute;
  bottom: 2px;
  right: 2px;
  transform: translate(20%, 20%);
  width: 34px;
  height: 34px;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);
  border: 3px solid white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(26,115,232,0.5);
  z-index: 3;
  transition: transform 0.25s var(--ease), box-shadow 0.25s;
}

.camera-icon:hover {
  transform: translate(20%, 20%) scale(1.14);
  box-shadow: 0 6px 20px rgba(26,115,232,0.65);
}

.camera-icon i { font-size: 13px; color: white; }
.profile-image-input { display: none; }

/* ══════════════════════════════════════
   TITLE + USERNAME CHIP
══════════════════════════════════════ */
.user-profile-title {
  font-family: var(--font);
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.5px;
  text-align: center;
  padding: 8px 40px 2px;
  margin: 0;
}

.profile-username-chip {
  text-align: center;
  font-family: var(--font-mono);
  font-size: 12.5px;
  color: var(--accent);
  font-weight: 500;
  margin-bottom: 20px;
  letter-spacing: 0.3px;
}

/* ══════════════════════════════════════
   MESSAGE
══════════════════════════════════════ */
.form-message {
  margin: 0 40px 16px;
  padding: 12px 18px;
  border-radius: 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  font-family: var(--font);
}

.form-message.success {
  background: var(--success-soft);
  color: var(--success);
  border: 1px solid rgba(34,197,94,0.28);
}

.form-message.error {
  background: var(--danger-soft);
  color: var(--danger);
  border: 1px solid rgba(239,68,68,0.28);
}

/* ══════════════════════════════════════
   PROFILE INFO VIEW
══════════════════════════════════════ */
.profile-info-section {
  padding: 0 36px 32px;
}

.profile-fields {
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 24px;
  background: var(--surface);
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}

.profile-field-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
  transition: background 0.15s;
  gap: 12px;
}

.profile-field-row:last-child { border-bottom: none; }

.profile-field-row:hover { background: var(--surface-2); }

.pf-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--text-muted);
  flex-shrink: 0;
  min-width: 120px;
}

.pf-value {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  text-align: right;
  word-break: break-word;
}

/* ══════════════════════════════════════
   PROFILE BUTTON ROW
══════════════════════════════════════ */
.profile-button-row {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn-edit {
  flex: 1 1;
  max-width: 210px;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: white;
  border: none;
  padding: 13px 24px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.25s var(--ease);
  box-shadow: 0 4px 16px var(--accent-glow);
  letter-spacing: 0.1px;
}

.btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(26,115,232,0.42);
}

.btn-logout {
  flex: 1 1;
  max-width: 210px;
  background: white;
  color: var(--danger);
  border: 1.5px solid var(--danger);
  padding: 13px 24px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.25s var(--ease);
}

.btn-logout:hover {
  background: var(--danger-soft);
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(239,68,68,0.18);
}

/* ══════════════════════════════════════
   EDIT FORM
══════════════════════════════════════ */
.profile-edit-form {
  padding: 4px 36px 32px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 14px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-row .form-group {
  margin-bottom: 0;
}

.form-group label {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.9px;
  color: var(--text-muted);
  font-family: var(--font);
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 11px 14px;
  border: 1.5px solid var(--border);
  border-radius: 12px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  background: var(--surface-2);
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  outline: none;
  appearance: none;
}

.form-group input::placeholder {
  color: var(--text-muted);
  font-weight: 400;
}

.form-group input:focus,
.form-group select:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 4px var(--accent-soft);
  background: white;
}

.form-group select:disabled {
  background: #f3f4f6;
  color: var(--text-muted);
  cursor: not-allowed;
}

/* ── Form Action Buttons ── */
.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  justify-content: center;
}

.btn-save {
  flex: 1 1;
  max-width: 220px;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: white;
  border: none;
  padding: 13px 28px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s var(--ease);
  box-shadow: 0 4px 16px var(--accent-glow);
  letter-spacing: 0.2px;
}

.btn-save:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 26px rgba(26,115,232,0.42);
}

.btn-cancel {
  flex: 1 1;
  max-width: 160px;
  background: white;
  color: var(--text-secondary);
  border: 1.5px solid var(--border);
  padding: 13px 24px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s var(--ease);
}

.btn-cancel:hover {
  background: var(--surface-2);
  border-color: var(--border-hover, #c4c9d4);
  color: var(--text-primary);
  transform: translateY(-1px);
}

/* ══════════════════════════════════════
   LOADING
══════════════════════════════════════ */
.loading-container-user {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: var(--bg);
}

.loading-spinner-user {
  border: 3px solid var(--accent-soft);
  border-top: 3px solid var(--accent);
  border-radius: 50%;
  width: 42px;
  height: 42px;
  animation: spin 0.7s linear infinite;
  box-shadow: 0 0 18px var(--accent-glow);
}

.button-spinner {
  border: 2px solid rgba(255,255,255,0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 0.7s linear infinite;
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes spin { to { transform: rotate(360deg); } }

/* ══════════════════════════════════════
   DANGER ZONE — account deletion
══════════════════════════════════════ */
.profile-danger-zone {
  margin-top: 8px;
  padding: 24px 36px 36px;
  border-top: 1px solid var(--border);
  background: linear-gradient(180deg, var(--surface-2) 0%, var(--surface) 100%);
}

.danger-zone-title {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--danger);
  margin-bottom: 10px;
}

.danger-zone-text {
  font-size: 13px;
  line-height: 1.55;
  color: var(--text-secondary);
  margin-bottom: 16px;
  max-width: 520px;
}

.btn-delete-account {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  border: 1.5px solid var(--danger);
  background: var(--danger-soft);
  color: #b91c1c;
  transition: all 0.25s var(--ease);
}

.btn-delete-account:hover {
  background: #fee2e2;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.2);
}

.delete-account-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(15, 17, 23, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  backdrop-filter: blur(5px);
}

.delete-account-modal {
  width: 100%;
  max-width: 440px;
  background: var(--surface);
  border-radius: 18px;
  border: 1px solid var(--border);
  box-shadow:
    0 24px 64px rgba(0, 0, 0, 0.18),
    0 0 0 1px rgba(0, 0, 0, 0.04);
  padding: 26px 24px 22px;
  font-family: var(--font);
}

.delete-account-modal-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 10px;
}

.delete-account-modal-hint {
  font-size: 12px;
  line-height: 1.5;
  color: var(--text-secondary);
  margin-bottom: 16px;
}

.delete-account-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted);
  margin-bottom: 6px;
  margin-top: 12px;
}

.delete-account-label:first-of-type {
  margin-top: 0;
}

.delete-account-input {
  width: 100%;
  padding: 11px 14px;
  border-radius: 10px;
  border: 1px solid var(--border);
  font-family: var(--font);
  font-size: 14px;
  color: var(--text-primary);
  background: var(--surface-2);
  transition: border-color 0.2s;
}

.delete-account-input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.delete-account-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 22px;
  flex-wrap: wrap;
}

.btn-delete-cancel {
  padding: 11px 20px;
  border-radius: 100px;
  border: 1px solid var(--border);
  background: white;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 0.2s;
}

.btn-delete-cancel:hover:not(:disabled) {
  background: var(--surface-2);
}

.btn-delete-confirm {
  padding: 11px 20px;
  border-radius: 100px;
  border: none;
  background: var(--danger);
  color: white;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: filter 0.2s, transform 0.2s;
}

.btn-delete-confirm:hover:not(:disabled) {
  filter: brightness(1.05);
  transform: translateY(-1px);
}

.btn-delete-cancel:disabled,
.btn-delete-confirm:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* ══════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════ */
@media (max-width: 680px) {
  .profile-page-bg { padding: 80px 12px 48px; }

  .user-profile-card { border-radius: 18px; }

  .user-profile-card::before { height: 90px; }

  .profile-image-section { margin-top: -46px; }

  .user-profile-title { padding: 8px 20px 2px; font-size: 1.3rem; }

  .profile-info-section,
  .profile-edit-form,
  .profile-danger-zone { padding-left: 20px; padding-right: 20px; }

  .form-row { grid-template-columns: 1fr; }

  .profile-button-row,
  .form-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-edit, .btn-logout, .btn-save, .btn-cancel {
    max-width: 100%;
    justify-content: center;
  }

  .pf-label { min-width: 100px; }
}`, "",{"version":3,"sources":["webpack://./src/components/User.css"],"names":[],"mappings":"AAEA;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,mCAAmC;EACnC,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA,IAAI,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAEnD;;wCAEwC;AACxC;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB;;;gCAG8B;EAC9B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,uFAAuF;AACzF;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,aAAa;EACb;;;;GAIC;EACD,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB;;qCAEmC;EACnC,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,uCAAuC;EACvC;;qCAEmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,sDAAsD,UAAU,EAAE;AAClE,2BAA2B,YAAY,EAAE,eAAe,EAAE;;AAE1D;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,8EAA8E;EAC9E,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2CAA2C;EAC3C,UAAU;EACV,yDAAyD;AAC3D;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA,iBAAiB,eAAe,EAAE,YAAY,EAAE;AAChD,uBAAuB,aAAa,EAAE;;AAEtC;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;wCAEwC;AACxC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;;wCAEwC;AACxC;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,SAAS;AACX;;AAEA,gCAAgC,mBAAmB,EAAE;;AAErD,2BAA2B,4BAA4B,EAAE;;AAEzD;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;EACjC,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;wCAEwC;AACxC;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,+DAA+D;EAC/D,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;;wCAEwC;AACxC;EACE,eAAe;EACf,uBAAuB;EACvB,mCAAmC;EACnC,6EAA6E;AAC/E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,8BAA8B;EAC9B,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,+BAA+B;EAC/B;;iCAE+B;EAC/B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;EACE,mBAAmB,uBAAuB,EAAE;;EAE5C,qBAAqB,mBAAmB,EAAE;;EAE1C,6BAA6B,YAAY,EAAE;;EAE3C,yBAAyB,iBAAiB,EAAE;;EAE5C,sBAAsB,qBAAqB,EAAE,iBAAiB,EAAE;;EAEhE;;yBAEuB,kBAAkB,EAAE,mBAAmB,EAAE;;EAEhE,YAAY,0BAA0B,EAAE;;EAExC;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA,YAAY,gBAAgB,EAAE;AAChC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap');\n\n/* ══════════════════════════════════════\n   DESIGN TOKENS\n══════════════════════════════════════ */\n:root {\n  --bg:            #f0f2f5;\n  --surface:       #ffffff;\n  --surface-2:     #f7f8fa;\n  --border:        #e4e7ed;\n  --accent:        #1a73e8;\n  --accent-dark:   #1252a3;\n  --accent-soft:   #e8f0fe;\n  --accent-glow:   rgba(26,115,232,0.22);\n  --danger:        #ef4444;\n  --danger-soft:   #fef2f2;\n  --success:       #22c55e;\n  --success-soft:  #f0fdf4;\n  --text-primary:  #0f1117;\n  --text-secondary:#4b5563;\n  --text-muted:    #9ca3af;\n  --font:          'Sora', sans-serif;\n  --font-mono:     'JetBrains Mono', monospace;\n  --ease:          cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n* { box-sizing: border-box; margin: 0; padding: 0; }\n\n/* ══════════════════════════════════════\n   PAGE BACKGROUND\n══════════════════════════════════════ */\n.profile-page-bg {\n  min-height: 100vh;\n  background-color: var(--bg);\n  padding: 90px 20px 60px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  font-family: var(--font);\n}\n\n/* ══════════════════════════════════════\n   PROFILE CARD\n══════════════════════════════════════ */\n.user-profile-card {\n  width: 100%;\n  max-width: 620px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 24px;\n  box-shadow:\n    0 1px 3px rgba(0,0,0,0.05),\n    0 8px 32px rgba(0,0,0,0.09),\n    0 40px 80px rgba(0,0,0,0.05);\n  overflow: hidden;\n  animation: cardIn 0.45s var(--ease) both;\n}\n\n@keyframes cardIn {\n  from { opacity: 0; transform: translateY(24px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* ── Hero Banner ── */\n.user-profile-card::before {\n  content: '';\n  display: block;\n  height: 110px;\n  background: linear-gradient(135deg, #1252a3 0%, #1a73e8 50%, #4a9af5 85%, #74b9ff 100%);\n}\n\n/* Subtle diagonal stripe texture on banner */\n.user-profile-card::after {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 110px;\n  background-image: repeating-linear-gradient(\n    -55deg,\n    transparent 0px, transparent 18px,\n    rgba(255,255,255,0.04) 18px, rgba(255,255,255,0.04) 36px\n  );\n  pointer-events: none;\n  border-radius: 24px 24px 0 0;\n}\n\n/* ══════════════════════════════════════\n   AVATAR\n══════════════════════════════════════ */\n.profile-image-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: -56px;\n  margin-bottom: 10px;\n  position: relative;\n  z-index: 2;\n}\n\n.profile-image-wrapper {\n  position: relative;\n  width: 112px;\n  height: 112px;\n  border-radius: 50%;\n  overflow: visible;\n  border: 4px solid #fff;\n  box-shadow:\n    0 0 0 3px var(--accent),\n    0 12px 40px rgba(26,115,232,0.30);\n  cursor: pointer;\n  transition: box-shadow 0.3s var(--ease), transform 0.3s var(--ease);\n}\n\n.profile-image-wrapper:hover {\n  transform: scale(1.05) translateY(-2px);\n  box-shadow:\n    0 0 0 4px var(--accent),\n    0 20px 50px rgba(26,115,232,0.42);\n}\n\n.profile-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n  display: block;\n}\n\n.profile-image-overlay {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: rgba(18,82,163,0.50);\n  opacity: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.25s ease;\n}\n\n.profile-image-wrapper:hover .profile-image-overlay { opacity: 1; }\n.profile-image-overlay i { color: white; font-size: 20px; }\n\n.camera-icon {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  transform: translate(20%, 20%);\n  width: 34px;\n  height: 34px;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);\n  border: 3px solid white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(26,115,232,0.5);\n  z-index: 3;\n  transition: transform 0.25s var(--ease), box-shadow 0.25s;\n}\n\n.camera-icon:hover {\n  transform: translate(20%, 20%) scale(1.14);\n  box-shadow: 0 6px 20px rgba(26,115,232,0.65);\n}\n\n.camera-icon i { font-size: 13px; color: white; }\n.profile-image-input { display: none; }\n\n/* ══════════════════════════════════════\n   TITLE + USERNAME CHIP\n══════════════════════════════════════ */\n.user-profile-title {\n  font-family: var(--font);\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.5px;\n  text-align: center;\n  padding: 8px 40px 2px;\n  margin: 0;\n}\n\n.profile-username-chip {\n  text-align: center;\n  font-family: var(--font-mono);\n  font-size: 12.5px;\n  color: var(--accent);\n  font-weight: 500;\n  margin-bottom: 20px;\n  letter-spacing: 0.3px;\n}\n\n/* ══════════════════════════════════════\n   MESSAGE\n══════════════════════════════════════ */\n.form-message {\n  margin: 0 40px 16px;\n  padding: 12px 18px;\n  border-radius: 12px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: var(--font);\n}\n\n.form-message.success {\n  background: var(--success-soft);\n  color: var(--success);\n  border: 1px solid rgba(34,197,94,0.28);\n}\n\n.form-message.error {\n  background: var(--danger-soft);\n  color: var(--danger);\n  border: 1px solid rgba(239,68,68,0.28);\n}\n\n/* ══════════════════════════════════════\n   PROFILE INFO VIEW\n══════════════════════════════════════ */\n.profile-info-section {\n  padding: 0 36px 32px;\n}\n\n.profile-fields {\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  overflow: hidden;\n  margin-bottom: 24px;\n  background: var(--surface);\n  box-shadow: 0 1px 4px rgba(0,0,0,0.05);\n}\n\n.profile-field-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--border);\n  transition: background 0.15s;\n  gap: 12px;\n}\n\n.profile-field-row:last-child { border-bottom: none; }\n\n.profile-field-row:hover { background: var(--surface-2); }\n\n.pf-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--text-muted);\n  flex-shrink: 0;\n  min-width: 120px;\n}\n\n.pf-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  text-align: right;\n  word-break: break-word;\n}\n\n/* ══════════════════════════════════════\n   PROFILE BUTTON ROW\n══════════════════════════════════════ */\n.profile-button-row {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.btn-edit {\n  flex: 1;\n  max-width: 210px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\n  color: white;\n  border: none;\n  padding: 13px 24px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.25s var(--ease);\n  box-shadow: 0 4px 16px var(--accent-glow);\n  letter-spacing: 0.1px;\n}\n\n.btn-edit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 28px rgba(26,115,232,0.42);\n}\n\n.btn-logout {\n  flex: 1;\n  max-width: 210px;\n  background: white;\n  color: var(--danger);\n  border: 1.5px solid var(--danger);\n  padding: 13px 24px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all 0.25s var(--ease);\n}\n\n.btn-logout:hover {\n  background: var(--danger-soft);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 14px rgba(239,68,68,0.18);\n}\n\n/* ══════════════════════════════════════\n   EDIT FORM\n══════════════════════════════════════ */\n.profile-edit-form {\n  padding: 4px 36px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-row .form-group {\n  margin-bottom: 0;\n}\n\n.form-group label {\n  font-size: 10.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.9px;\n  color: var(--text-muted);\n  font-family: var(--font);\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 11px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: 12px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  background: var(--surface-2);\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n  outline: none;\n  appearance: none;\n}\n\n.form-group input::placeholder {\n  color: var(--text-muted);\n  font-weight: 400;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 4px var(--accent-soft);\n  background: white;\n}\n\n.form-group select:disabled {\n  background: #f3f4f6;\n  color: var(--text-muted);\n  cursor: not-allowed;\n}\n\n/* ── Form Action Buttons ── */\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n  justify-content: center;\n}\n\n.btn-save {\n  flex: 1;\n  max-width: 220px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\n  color: white;\n  border: none;\n  padding: 13px 28px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.25s var(--ease);\n  box-shadow: 0 4px 16px var(--accent-glow);\n  letter-spacing: 0.2px;\n}\n\n.btn-save:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 26px rgba(26,115,232,0.42);\n}\n\n.btn-cancel {\n  flex: 1;\n  max-width: 160px;\n  background: white;\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border);\n  padding: 13px 24px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.25s var(--ease);\n}\n\n.btn-cancel:hover {\n  background: var(--surface-2);\n  border-color: var(--border-hover, #c4c9d4);\n  color: var(--text-primary);\n  transform: translateY(-1px);\n}\n\n/* ══════════════════════════════════════\n   LOADING\n══════════════════════════════════════ */\n.loading-container-user {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: var(--bg);\n}\n\n.loading-spinner-user {\n  border: 3px solid var(--accent-soft);\n  border-top: 3px solid var(--accent);\n  border-radius: 50%;\n  width: 42px;\n  height: 42px;\n  animation: spin 0.7s linear infinite;\n  box-shadow: 0 0 18px var(--accent-glow);\n}\n\n.button-spinner {\n  border: 2px solid rgba(255,255,255,0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  width: 15px;\n  height: 15px;\n  animation: spin 0.7s linear infinite;\n  display: inline-block;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* ══════════════════════════════════════\n   DANGER ZONE — account deletion\n══════════════════════════════════════ */\n.profile-danger-zone {\n  margin-top: 8px;\n  padding: 24px 36px 36px;\n  border-top: 1px solid var(--border);\n  background: linear-gradient(180deg, var(--surface-2) 0%, var(--surface) 100%);\n}\n\n.danger-zone-title {\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--danger);\n  margin-bottom: 10px;\n}\n\n.danger-zone-text {\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n  max-width: 520px;\n}\n\n.btn-delete-account {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 11px 20px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1.5px solid var(--danger);\n  background: var(--danger-soft);\n  color: #b91c1c;\n  transition: all 0.25s var(--ease);\n}\n\n.btn-delete-account:hover {\n  background: #fee2e2;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.2);\n}\n\n.delete-account-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  background: rgba(15, 17, 23, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  backdrop-filter: blur(5px);\n}\n\n.delete-account-modal {\n  width: 100%;\n  max-width: 440px;\n  background: var(--surface);\n  border-radius: 18px;\n  border: 1px solid var(--border);\n  box-shadow:\n    0 24px 64px rgba(0, 0, 0, 0.18),\n    0 0 0 1px rgba(0, 0, 0, 0.04);\n  padding: 26px 24px 22px;\n  font-family: var(--font);\n}\n\n.delete-account-modal-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 10px;\n}\n\n.delete-account-modal-hint {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  margin-bottom: 16px;\n}\n\n.delete-account-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-muted);\n  margin-bottom: 6px;\n  margin-top: 12px;\n}\n\n.delete-account-label:first-of-type {\n  margin-top: 0;\n}\n\n.delete-account-input {\n  width: 100%;\n  padding: 11px 14px;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n  font-family: var(--font);\n  font-size: 14px;\n  color: var(--text-primary);\n  background: var(--surface-2);\n  transition: border-color 0.2s;\n}\n\n.delete-account-input:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n.delete-account-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 22px;\n  flex-wrap: wrap;\n}\n\n.btn-delete-cancel {\n  padding: 11px 20px;\n  border-radius: 100px;\n  border: 1px solid var(--border);\n  background: white;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-delete-cancel:hover:not(:disabled) {\n  background: var(--surface-2);\n}\n\n.btn-delete-confirm {\n  padding: 11px 20px;\n  border-radius: 100px;\n  border: none;\n  background: var(--danger);\n  color: white;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: filter 0.2s, transform 0.2s;\n}\n\n.btn-delete-confirm:hover:not(:disabled) {\n  filter: brightness(1.05);\n  transform: translateY(-1px);\n}\n\n.btn-delete-cancel:disabled,\n.btn-delete-confirm:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* ══════════════════════════════════════\n   RESPONSIVE\n══════════════════════════════════════ */\n@media (max-width: 680px) {\n  .profile-page-bg { padding: 80px 12px 48px; }\n\n  .user-profile-card { border-radius: 18px; }\n\n  .user-profile-card::before { height: 90px; }\n\n  .profile-image-section { margin-top: -46px; }\n\n  .user-profile-title { padding: 8px 20px 2px; font-size: 1.3rem; }\n\n  .profile-info-section,\n  .profile-edit-form,\n  .profile-danger-zone { padding-left: 20px; padding-right: 20px; }\n\n  .form-row { grid-template-columns: 1fr; }\n\n  .profile-button-row,\n  .form-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .btn-edit, .btn-logout, .btn-save, .btn-cancel {\n    max-width: 100%;\n    justify-content: center;\n  }\n\n  .pf-label { min-width: 100px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
